// Auto-generated by backend/generate_install.py — Install App (APK / PWA) labels (11 languages).
export const INSTALL_UI = {
  "title": {
    "id": "Pasang Aplikasi Manasik",
    "en": "Install the Manasik App",
    "ar": "ثبِّت تطبيق المناسك",
    "fr": "Installer l'application Manasik",
    "de": "Manasik-App installieren",
    "es": "Instalar la aplicación Manasik",
    "ru": "Установить приложение Manasik",
    "zh": "安装 Manasik 应用",
    "ja": "Manasik アプリをインストール",
    "ko": "Manasik 앱 설치",
    "hi": "Manasik ऐप इंस्टॉल करें"
  },
  "subtitle": {
    "id": "Gunakan Manasik seperti aplikasi asli: ikon di layar utama, layar penuh, dan akses lebih cepat di Tanah Suci.",
    "en": "Use Manasik like a native app: icon on your home screen, full-screen display, and faster access in the Holy Land.",
    "ar": "استخدم تطبيق المناسك كتطبيق أصيل: أيقونة على الشاشة الرئيسية، وعرض بملء الشاشة، ووصول أسرع في الأراضي المقدسة.",
    "fr": "Utilisez Manasik comme une application native : icône sur l'écran d'accueil, affichage plein écran et accès plus rapide en Terre Sainte.",
    "de": "Nutzen Sie Manasik wie eine native App: Symbol auf dem Startbildschirm, Vollbildanzeige und schnellerer Zugriff im Heiligen Land.",
    "es": "Usa Manasik como una aplicación nativa: icono en la pantalla de inicio, pantalla completa y acceso más rápido en Tierra Santa.",
    "ru": "Используйте Manasik как нативное приложение: значок на главном экране, полноэкранный режим и быстрый доступ на Святой земле.",
    "zh": "像原生应用一样使用 Manasik：主屏幕图标、全屏显示，在圣地访问更快捷。",
    "ja": "Manasik をネイティブアプリのように使用できます：ホーム画面のアイコン、全画面表示、聖地でのより素早いアクセス。",
    "ko": "Manasik를 네이티브 앱처럼 사용하세요: 홈 화면 아이콘, 전체 화면 표시, 성지에서 더 빠른 접근.",
    "hi": "Manasik को एक नेटिव ऐप की तरह उपयोग करें: होम स्क्रीन पर आइकन, फुल-स्क्रीन डिस्प्ले, और पवित्र भूमि में तेज़ पहुँच।"
  },
  "homeTitle": {
    "id": "Pasang aplikasi di HP Anda",
    "en": "Install the app on your phone",
    "ar": "ثبِّت التطبيق على هاتفك",
    "fr": "Installer l'application sur votre téléphone",
    "de": "App auf Ihrem Smartphone installieren",
    "es": "Instalar la aplicación en tu teléfono",
    "ru": "Установить приложение на телефон",
    "zh": "在您的手机上安装应用",
    "ja": "スマートフォンにアプリをインストール",
    "ko": "휴대폰에 앱 설치",
    "hi": "अपने फ़ोन पर ऐप इंस्टॉल करें"
  },
  "homeHint": {
    "id": "Android (APK) · iPhone · Desktop — gratis, tanpa Play Store",
    "en": "Android (APK) · iPhone · Desktop — free, no Play Store required",
    "ar": "أندرويد (APK) · آيفون · سطح المكتب — مجاني، بدون متجر Play",
    "fr": "Android (APK) · iPhone · Bureau — gratuit, sans Play Store",
    "de": "Android (APK) · iPhone · Desktop — kostenlos, ohne Play Store",
    "es": "Android (APK) · iPhone · Escritorio — gratis, sin Play Store",
    "ru": "Android (APK) · iPhone · Компьютер — бесплатно, без Play Store",
    "zh": "Android（APK）· iPhone · 桌面端 — 免费，无需 Play 商店",
    "ja": "Android（APK）· iPhone · デスクトップ — 無料、Play ストア不要",
    "ko": "Android(APK) · iPhone · 데스크톱 — 무료, Play 스토어 불필요",
    "hi": "Android (APK) · iPhone · Desktop — मुफ़्त, Play Store की ज़रूरत नहीं"
  },
  "homeCta": {
    "id": "Pasang",
    "en": "Install",
    "ar": "ثبِّت",
    "fr": "Installer",
    "de": "Installieren",
    "es": "Instalar",
    "ru": "Установить",
    "zh": "安装",
    "ja": "インストール",
    "ko": "설치",
    "hi": "इंस्टॉल करें"
  },
  "homeGuide": {
    "id": "Panduan pemasangan",
    "en": "Installation guide",
    "ar": "دليل التثبيت",
    "fr": "Guide d'installation",
    "de": "Installationsanleitung",
    "es": "Guía de instalación",
    "ru": "Руководство по установке",
    "zh": "安装指南",
    "ja": "インストールガイド",
    "ko": "설치 가이드",
    "hi": "इंस्टॉलेशन गाइड"
  },
  "dismiss": {
    "id": "Sembunyikan",
    "en": "Hide",
    "ar": "إخفاء",
    "fr": "Masquer",
    "de": "Ausblenden",
    "es": "Ocultar",
    "ru": "Скрыть",
    "zh": "隐藏",
    "ja": "非表示",
    "ko": "숨기기",
    "hi": "छुपाएं"
  },
  "androidTitle": {
    "id": "Android — pasang berkas APK",
    "en": "Android — Install APK File",
    "ar": "Android — تثبيت ملف APK",
    "fr": "Android — Installer le fichier APK",
    "de": "Android — APK-Datei installieren",
    "es": "Android — Instalar archivo APK",
    "ru": "Android — Установить APK-файл",
    "zh": "Android — 安装 APK 文件",
    "ja": "Android — APKファイルをインストール",
    "ko": "Android — APK 파일 설치",
    "hi": "Android — APK फ़ाइल इंस्टॉल करें"
  },
  "androidHint": {
    "id": "Aplikasi Android resmi Manasik, ditandatangani secara digital. Berjalan di atas Google Chrome (Trusted Web Activity).",
    "en": "The official Manasik Android app, digitally signed. Runs on Google Chrome (Trusted Web Activity).",
    "ar": "تطبيق Manasik الرسمي لنظام Android، موقَّع رقمياً. يعمل على متصفح Google Chrome (Trusted Web Activity).",
    "fr": "L'application Android officielle Manasik, signée numériquement. Fonctionne sur Google Chrome (Trusted Web Activity).",
    "de": "Die offizielle Manasik Android-App, digital signiert. Läuft auf Google Chrome (Trusted Web Activity).",
    "es": "La aplicación oficial Manasik para Android, firmada digitalmente. Se ejecuta en Google Chrome (Trusted Web Activity).",
    "ru": "Официальное приложение Manasik для Android, с цифровой подписью. Работает на Google Chrome (Trusted Web Activity).",
    "zh": "官方 Manasik Android 应用，经过数字签名。运行于 Google Chrome（Trusted Web Activity）。",
    "ja": "公式 Manasik Android アプリ、デジタル署名済み。Google Chrome（Trusted Web Activity）上で動作します。",
    "ko": "공식 Manasik Android 앱, 디지털 서명됨. Google Chrome (Trusted Web Activity) 위에서 실행됩니다.",
    "hi": "आधिकारिक Manasik Android ऐप, डिजिटल रूप से हस्ताक्षरित। Google Chrome (Trusted Web Activity) पर चलता है।"
  },
  "downloadApk": {
    "id": "Unduh APK ({mb} MB)",
    "en": "Download APK ({mb} MB)",
    "ar": "تنزيل APK ({mb} ميغابايت)",
    "fr": "Télécharger l'APK ({mb} Mo)",
    "de": "APK herunterladen ({mb} MB)",
    "es": "Descargar APK ({mb} MB)",
    "ru": "Скачать APK ({mb} МБ)",
    "zh": "下载 APK（{mb} MB）",
    "ja": "APK をダウンロード（{mb} MB）",
    "ko": "APK 다운로드 ({mb} MB)",
    "hi": "APK डाउनलोड करें ({mb} MB)"
  },
  "version": {
    "id": "Versi {v}",
    "en": "Version {v}",
    "ar": "الإصدار {v}",
    "fr": "Version {v}",
    "de": "Version {v}",
    "es": "Versión {v}",
    "ru": "Версия {v}",
    "zh": "版本 {v}",
    "ja": "バージョン {v}",
    "ko": "버전 {v}",
    "hi": "संस्करण {v}"
  },
  "package": {
    "id": "Paket {pkg}",
    "en": "Package {pkg}",
    "ar": "الحزمة {pkg}",
    "fr": "Paquet {pkg}",
    "de": "Paket {pkg}",
    "es": "Paquete {pkg}",
    "ru": "Пакет {pkg}",
    "zh": "包名 {pkg}",
    "ja": "パッケージ {pkg}",
    "ko": "패키지 {pkg}",
    "hi": "पैकेज {pkg}"
  },
  "requires": {
    "id": "Android 5.0+ dan Google Chrome terpasang",
    "en": "Android 5.0+ and Google Chrome installed",
    "ar": "نظام Android 5.0+ ومتصفح Google Chrome مثبَّت",
    "fr": "Android 5.0+ et Google Chrome installé",
    "de": "Android 5.0+ und Google Chrome installiert",
    "es": "Android 5.0+ y Google Chrome instalado",
    "ru": "Android 5.0+ и Google Chrome установлен",
    "zh": "需要 Android 5.0+ 并已安装 Google Chrome",
    "ja": "Android 5.0以上およびGoogle Chromeがインストールされていること",
    "ko": "Android 5.0+ 및 Google Chrome 설치 필요",
    "hi": "Android 5.0+ और Google Chrome इंस्टॉल होना आवश्यक है"
  },
  "scanQr": {
    "id": "Pindai kode QR ini dengan kamera HP Android Anda untuk mengunduh APK langsung.",
    "en": "Scan this QR code with your Android phone's camera to download the APK directly.",
    "ar": "امسح رمز QR هذا بكاميرا هاتفك الأندرويد لتنزيل ملف APK مباشرةً.",
    "fr": "Scannez ce code QR avec l'appareil photo de votre téléphone Android pour télécharger l'APK directement.",
    "de": "Scannen Sie diesen QR-Code mit der Kamera Ihres Android-Handys, um die APK direkt herunterzuladen.",
    "es": "Escanea este código QR con la cámara de tu teléfono Android para descargar el APK directamente.",
    "ru": "Отсканируйте этот QR-код камерой вашего Android-телефона, чтобы напрямую загрузить APK.",
    "zh": "用您的 Android 手机摄像头扫描此二维码，直接下载 APK。",
    "ja": "お使いのAndroidスマートフォンのカメラでこのQRコードをスキャンして、APKを直接ダウンロードしてください。",
    "ko": "Android 스마트폰 카메라로 이 QR 코드를 스캔하여 APK를 직접 다운로드하세요.",
    "hi": "APK सीधे डाउनलोड करने के लिए अपने Android फ़ोन के कैमरे से इस QR कोड को स्कैन करें।"
  },
  "copyLink": {
    "id": "Salin tautan",
    "en": "Copy link",
    "ar": "نسخ الرابط",
    "fr": "Copier le lien",
    "de": "Link kopieren",
    "es": "Copiar enlace",
    "ru": "Копировать ссылку",
    "zh": "复制链接",
    "ja": "リンクをコピー",
    "ko": "링크 복사",
    "hi": "लिंक कॉपी करें"
  },
  "linkCopied": {
    "id": "Tautan APK disalin",
    "en": "APK link copied",
    "ar": "تم نسخ رابط APK",
    "fr": "Lien APK copié",
    "de": "APK-Link kopiert",
    "es": "Enlace APK copiado",
    "ru": "Ссылка на APK скопирована",
    "zh": "APK 链接已复制",
    "ja": "APKリンクをコピーしました",
    "ko": "APK 링크가 복사되었습니다",
    "hi": "APK लिंक कॉपी किया गया"
  },
  "stepsTitle": {
    "id": "Langkah pemasangan",
    "en": "Installation steps",
    "ar": "خطوات التثبيت",
    "fr": "Étapes d'installation",
    "de": "Installationsschritte",
    "es": "Pasos de instalación",
    "ru": "Шаги установки",
    "zh": "安装步骤",
    "ja": "インストール手順",
    "ko": "설치 단계",
    "hi": "इंस्टॉलेशन के चरण"
  },
  "step1": {
    "id": "Ketuk Unduh APK (atau pindai kode QR dengan HP Android).",
    "en": "Tap Download APK (or scan the QR code with your Android phone).",
    "ar": "اضغط على «تنزيل APK» (أو امسح رمز QR بهاتفك الأندرويد).",
    "fr": "Appuyez sur Télécharger l'APK (ou scannez le code QR avec votre téléphone Android).",
    "de": "Tippen Sie auf APK herunterladen (oder scannen Sie den QR-Code mit Ihrem Android-Handy).",
    "es": "Toca Descargar APK (o escanea el código QR con tu teléfono Android).",
    "ru": "Нажмите «Скачать APK» (или отсканируйте QR-код с помощью Android-телефона).",
    "zh": "点击\"下载 APK\"（或用 Android 手机扫描二维码）。",
    "ja": "「APKをダウンロード」をタップします（またはAndroidスマートフォンでQRコードをスキャンします）。",
    "ko": "APK 다운로드를 탭하거나 Android 스마트폰으로 QR 코드를 스캔하세요.",
    "hi": "APK डाउनलोड करें पर टैप करें (या अपने Android फ़ोन से QR कोड स्कैन करें)।"
  },
  "step2": {
    "id": "Buka berkas yang terunduh dari notifikasi atau aplikasi Files.",
    "en": "Open the downloaded file from the notification or the Files app.",
    "ar": "افتح الملف الذي تم تنزيله من الإشعار أو تطبيق الملفات.",
    "fr": "Ouvrez le fichier téléchargé depuis la notification ou l'application Fichiers.",
    "de": "Öffnen Sie die heruntergeladene Datei aus der Benachrichtigung oder der Dateien-App.",
    "es": "Abre el archivo descargado desde la notificación o la aplicación Archivos.",
    "ru": "Откройте загруженный файл из уведомления или приложения «Файлы».",
    "zh": "从通知或文件应用中打开已下载的文件。",
    "ja": "通知またはファイルアプリからダウンロードしたファイルを開いてください。",
    "ko": "알림 또는 파일 앱에서 다운로드한 파일을 여세요.",
    "hi": "अधिसूचना या Files ऐप से डाउनलोड की गई फ़ाइल खोलें।"
  },
  "step3": {
    "id": "Jika diminta, izinkan \"Pasang aplikasi dari sumber tidak dikenal\" untuk Chrome/Files, lalu kembali.",
    "en": "If prompted, allow \"Install apps from unknown sources\" for Chrome/Files, then go back.",
    "ar": "إذا طُلب منك ذلك، اسمح بـ\"تثبيت التطبيقات من مصادر غير معروفة\" لـ Chrome/Files، ثم ارجع.",
    "fr": "Si une invite apparaît, autorisez \"Installer des applications de sources inconnues\" pour Chrome/Fichiers, puis revenez.",
    "de": "Falls Sie dazu aufgefordert werden, erlauben Sie „Apps aus unbekannten Quellen installieren\" für Chrome/Dateien, und kehren Sie dann zurück.",
    "es": "Si se solicita, permite \"Instalar aplicaciones de fuentes desconocidas\" para Chrome/Archivos y luego regresa.",
    "ru": "Если появится запрос, разрешите «Установку приложений из неизвестных источников» для Chrome/Файлов, затем вернитесь назад.",
    "zh": "如果出现提示，请为 Chrome/文件应用允许\"从未知来源安装应用\"，然后返回。",
    "ja": "求められた場合は、Chrome/ファイルに対して「不明なソースからのアプリのインストール」を許可し、戻ってください。",
    "ko": "요청이 표시되면 Chrome/파일에 대해 \"알 수 없는 출처의 앱 설치\"를 허용한 후 돌아오세요.",
    "hi": "यदि संकेत मिले, तो Chrome/Files के लिए \"अज्ञात स्रोतों से ऐप इंस्टॉल करें\" की अनुमति दें, फिर वापस जाएं।"
  },
  "step4": {
    "id": "Ketuk Pasang dan tunggu hingga selesai. Ikon Manasik akan muncul di layar utama.",
    "en": "Tap Install and wait until it finishes. The Manasik icon will appear on your home screen.",
    "ar": "اضغط على تثبيت وانتظر حتى يكتمل. ستظهر أيقونة Manasik على الشاشة الرئيسية.",
    "fr": "Appuyez sur Installer et attendez la fin. L'icône Manasik apparaîtra sur votre écran d'accueil.",
    "de": "Tippen Sie auf Installieren und warten Sie, bis der Vorgang abgeschlossen ist. Das Manasik-Symbol erscheint auf Ihrem Startbildschirm.",
    "es": "Toca Instalar y espera a que finalice. El ícono de Manasik aparecerá en tu pantalla de inicio.",
    "ru": "Нажмите «Установить» и дождитесь завершения. Значок Manasik появится на главном экране.",
    "zh": "点击安装并等待完成。Manasik 图标将出现在您的主屏幕上。",
    "ja": "「インストール」をタップして完了するまで待ちます。Manasik のアイコンがホーム画面に表示されます。",
    "ko": "설치를 탭하고 완료될 때까지 기다리세요. Manasik 아이콘이 홈 화면에 나타납니다.",
    "hi": "इंस्टॉल पर टैप करें और पूरा होने तक प्रतीक्षा करें। Manasik का आइकन आपकी होम स्क्रीन पर दिखाई देगा।"
  },
  "playProtect": {
    "id": "Jika muncul peringatan Google Play Protect, pilih \"Pasang saja\" — aplikasi ini ditandatangani resmi oleh Manasik dan tidak berisi iklan atau pelacak.",
    "en": "If a Google Play Protect warning appears, select \"Install anyway\" — this app is officially signed by Manasik and contains no ads or trackers.",
    "ar": "إذا ظهر تحذير Google Play Protect، اختر \"تثبيت على أي حال\" — هذا التطبيق موقَّع رسمياً من قِبَل Manasik ولا يحتوي على إعلانات أو أدوات تتبع.",
    "fr": "Si un avertissement Google Play Protect apparaît, sélectionnez \"Installer quand même\" — cette application est officiellement signée par Manasik et ne contient ni publicités ni traqueurs.",
    "de": "Falls eine Google Play Protect-Warnung erscheint, wählen Sie „Trotzdem installieren\" — diese App ist offiziell von Manasik signiert und enthält keine Werbung oder Tracker.",
    "es": "Si aparece una advertencia de Google Play Protect, selecciona \"Instalar de todas formas\" — esta aplicación está firmada oficialmente por Manasik y no contiene anuncios ni rastreadores.",
    "ru": "Если появится предупреждение Google Play Protect, выберите «Всё равно установить» — это приложение официально подписано Manasik и не содержит рекламы или трекеров.",
    "zh": "如果出现 Google Play Protect 警告，请选择\"仍要安装\"——此应用已由 Manasik 正式签名，不含任何广告或追踪器。",
    "ja": "Google Play Protect の警告が表示された場合は、「このままインストール」を選択してください。このアプリは Manasik によって正式に署名されており、広告やトラッカーは含まれていません。",
    "ko": "Google Play Protect 경고가 나타나면 \"그래도 설치\"를 선택하세요 — 이 앱은 Manasik이 공식 서명한 앱으로 광고나 추적기가 포함되어 있지 않습니다.",
    "hi": "यदि Google Play Protect की चेतावनी दिखे, तो \"फिर भी इंस्टॉल करें\" चुनें — यह ऐप Manasik द्वारा आधिकारिक रूप से हस्ताक्षरित है और इसमें कोई विज्ञापन या ट्रैकर नहीं है।"
  },
  "verifyTitle": {
    "id": "Verifikasi berkas (SHA-256)",
    "en": "File Verification (SHA-256)",
    "ar": "التحقق من الملف (SHA-256)",
    "fr": "Vérification du fichier (SHA-256)",
    "de": "Dateiüberprüfung (SHA-256)",
    "es": "Verificación de archivo (SHA-256)",
    "ru": "Проверка файла (SHA-256)",
    "zh": "文件验证（SHA-256）",
    "ja": "ファイルの検証（SHA-256）",
    "ko": "파일 검증 (SHA-256)",
    "hi": "फ़ाइल सत्यापन (SHA-256)"
  },
  "verifyHint": {
    "id": "Cocokkan sidik jari ini dengan berkas yang Anda unduh untuk memastikan keasliannya.",
    "en": "Match this fingerprint with the file you downloaded to confirm its authenticity.",
    "ar": "طابق هذه البصمة مع الملف الذي قمت بتنزيله للتحقق من أصالته.",
    "fr": "Comparez cette empreinte avec le fichier que vous avez téléchargé pour confirmer son authenticité.",
    "de": "Gleichen Sie diesen Fingerabdruck mit der heruntergeladenen Datei ab, um deren Echtheit zu bestätigen.",
    "es": "Compara esta huella digital con el archivo que descargaste para confirmar su autenticidad.",
    "ru": "Сравните этот отпечаток с загруженным файлом, чтобы подтвердить его подлинность.",
    "zh": "将此指纹与您下载的文件进行比对，以确认其真实性。",
    "ja": "このフィンガープリントをダウンロードしたファイルと照合して、その真正性を確認してください。",
    "ko": "이 지문을 다운로드한 파일과 대조하여 진위 여부를 확인하세요.",
    "hi": "अपनी डाउनलोड की गई फ़ाइल से इस फ़िंगरप्रिंट का मिलान करें ताकि उसकी प्रामाणिकता सुनिश्चित हो सके।"
  },
  "pwaTitle": {
    "id": "iPhone, iPad & Desktop — pasang dari browser",
    "en": "iPhone, iPad & Desktop — Install from browser",
    "ar": "iPhone وiPad وسطح المكتب — ثبّت من المتصفح",
    "fr": "iPhone, iPad & Bureau — Installer depuis le navigateur",
    "de": "iPhone, iPad & Desktop — Aus dem Browser installieren",
    "es": "iPhone, iPad y escritorio — Instalar desde el navegador",
    "ru": "iPhone, iPad и рабочий стол — установите из браузера",
    "zh": "iPhone、iPad 和桌面端 — 从浏览器安装",
    "ja": "iPhone・iPad・デスクトップ — ブラウザからインストール",
    "ko": "iPhone, iPad 및 데스크톱 — 브라우저에서 설치",
    "hi": "iPhone, iPad और डेस्कटॉप — ब्राउज़र से इंस्टॉल करें"
  },
  "pwaHint": {
    "id": "Tanpa toko aplikasi: tambahkan Manasik ke layar utama langsung dari browser. Bekerja offline dan menerima notifikasi pengingat.",
    "en": "No app store needed: add Manasik to your home screen directly from the browser. Works offline and receives reminder notifications.",
    "ar": "بدون متجر تطبيقات: أضف تطبيق مناسك إلى شاشتك الرئيسية مباشرةً من المتصفح. يعمل بدون إنترنت ويستقبل إشعارات التذكير.",
    "fr": "Sans boutique d'applications : ajoutez Manasik à votre écran d'accueil directement depuis le navigateur. Fonctionne hors ligne et reçoit des notifications de rappel.",
    "de": "Kein App-Store nötig: Fügen Sie Manasik direkt aus dem Browser zu Ihrem Startbildschirm hinzu. Funktioniert offline und empfängt Erinnerungsbenachrichtigungen.",
    "es": "Sin tienda de aplicaciones: añade Manasik a tu pantalla de inicio directamente desde el navegador. Funciona sin conexión y recibe notificaciones de recordatorio.",
    "ru": "Без магазина приложений: добавьте Manasik на главный экран прямо из браузера. Работает офлайн и получает напоминания в виде уведомлений.",
    "zh": "无需应用商店：直接从浏览器将 Manasik 添加到主屏幕。支持离线使用并接收提醒通知。",
    "ja": "アプリストア不要：ブラウザから直接 Manasik をホーム画面に追加できます。オフラインで動作し、リマインダー通知を受け取れます。",
    "ko": "앱 스토어 불필요: 브라우저에서 직접 Manasik을 홈 화면에 추가하세요. 오프라인에서 작동하며 알림 미리 알림을 받습니다.",
    "hi": "ऐप स्टोर की आवश्यकता नहीं: ब्राउज़र से सीधे Manasik को अपनी होम स्क्रीन पर जोड़ें। ऑफ़लाइन काम करता है और रिमाइंडर सूचनाएं प्राप्त करता है।"
  },
  "installBtn": {
    "id": "Pasang Aplikasi",
    "en": "Install App",
    "ar": "ثبّت التطبيق",
    "fr": "Installer l'application",
    "de": "App installieren",
    "es": "Instalar aplicación",
    "ru": "Установить приложение",
    "zh": "安装应用",
    "ja": "アプリをインストール",
    "ko": "앱 설치",
    "hi": "ऐप इंस्टॉल करें"
  },
  "installing": {
    "id": "Membuka dialog pemasangan…",
    "en": "Opening installation dialog…",
    "ar": "جارٍ فتح نافذة التثبيت…",
    "fr": "Ouverture de la boîte de dialogue d'installation…",
    "de": "Installationsdialog wird geöffnet…",
    "es": "Abriendo el cuadro de diálogo de instalación…",
    "ru": "Открытие диалога установки…",
    "zh": "正在打开安装对话框……",
    "ja": "インストールダイアログを開いています…",
    "ko": "설치 대화상자를 여는 중…",
    "hi": "इंस्टॉलेशन डायलॉग खोला जा रहा है…"
  },
  "installed": {
    "id": "Aplikasi sudah terpasang di perangkat ini. Buka dari layar utama Anda.",
    "en": "The app is already installed on this device. Open it from your home screen.",
    "ar": "التطبيق مثبَّت بالفعل على هذا الجهاز. افتحه من شاشتك الرئيسية.",
    "fr": "L'application est déjà installée sur cet appareil. Ouvrez-la depuis votre écran d'accueil.",
    "de": "Die App ist bereits auf diesem Gerät installiert. Öffnen Sie sie über Ihren Startbildschirm.",
    "es": "La aplicación ya está instalada en este dispositivo. Ábrela desde tu pantalla de inicio.",
    "ru": "Приложение уже установлено на этом устройстве. Откройте его с главного экрана.",
    "zh": "该应用已安装在此设备上。请从您的主屏幕打开它。",
    "ja": "アプリはすでにこのデバイスにインストールされています。ホーム画面から開いてください。",
    "ko": "앱이 이미 이 기기에 설치되어 있습니다. 홈 화면에서 여세요.",
    "hi": "यह ऐप पहले से इस डिवाइस पर इंस्टॉल है। अपनी होम स्क्रीन से खोलें।"
  },
  "installedShort": {
    "id": "Sudah terpasang",
    "en": "Already installed",
    "ar": "مثبَّت بالفعل",
    "fr": "Déjà installée",
    "de": "Bereits installiert",
    "es": "Ya instalada",
    "ru": "Уже установлено",
    "zh": "已安装",
    "ja": "インストール済み",
    "ko": "이미 설치됨",
    "hi": "पहले से इंस्टॉल है"
  },
  "openApp": {
    "id": "Anda sedang menggunakan aplikasi yang terpasang. Alhamdulillah!",
    "en": "You are using the installed app. Alhamdulillah!",
    "ar": "أنتَ تستخدم التطبيق المثبَّت. الحمد لله!",
    "fr": "Vous utilisez l'application installée. Alhamdulillah !",
    "de": "Sie verwenden die installierte App. Alhamdulillah!",
    "es": "Estás usando la aplicación instalada. ¡Alhamdulillah!",
    "ru": "Вы используете установленное приложение. Альхамдулиллях!",
    "zh": "您正在使用已安装的应用程序。阿尔罕都里拉！",
    "ja": "インストール済みアプリを使用中です。アルハムドゥリッラー！",
    "ko": "설치된 앱을 사용 중입니다. 알함두릴라!",
    "hi": "आप इंस्टॉल किया गया ऐप उपयोग कर रहे हैं। अलहम्दुलिल्लाह!"
  },
  "installDismissed": {
    "id": "Pemasangan dibatalkan. Anda bisa mencobanya lagi kapan saja.",
    "en": "Installation cancelled. You can try again at any time.",
    "ar": "تم إلغاء التثبيت. يمكنك المحاولة مرةً أخرى في أي وقت.",
    "fr": "Installation annulée. Vous pouvez réessayer à tout moment.",
    "de": "Installation abgebrochen. Sie können es jederzeit erneut versuchen.",
    "es": "Instalación cancelada. Puedes intentarlo de nuevo en cualquier momento.",
    "ru": "Установка отменена. Вы можете повторить попытку в любое время.",
    "zh": "安装已取消。您可以随时重试。",
    "ja": "インストールがキャンセルされました。いつでも再試行できます。",
    "ko": "설치가 취소되었습니다. 언제든지 다시 시도할 수 있습니다.",
    "hi": "इंस्टॉलेशन रद्द कर दिया गया। आप इसे कभी भी दोबारा आज़मा सकते हैं।"
  },
  "installSuccess": {
    "id": "Manasik berhasil dipasang. Cari ikonnya di layar utama.",
    "en": "Manasik has been successfully installed. Find its icon on the home screen.",
    "ar": "تم تثبيت تطبيق المناسك بنجاح. ابحث عن أيقونته في الشاشة الرئيسية.",
    "fr": "Manasik a été installé avec succès. Trouvez son icône sur l'écran d'accueil.",
    "de": "Manasik wurde erfolgreich installiert. Suchen Sie das Symbol auf dem Startbildschirm.",
    "es": "Manasik se ha instalado correctamente. Encuentra su ícono en la pantalla de inicio.",
    "ru": "Manasik успешно установлен. Найдите его значок на главном экране.",
    "zh": "Manasik 已成功安装。请在主屏幕上找到其图标。",
    "ja": "Manasik のインストールが完了しました。ホーム画面でアイコンを見つけてください。",
    "ko": "Manasik이 성공적으로 설치되었습니다. 홈 화면에서 아이콘을 찾으세요.",
    "hi": "Manasik सफलतापूर्वक इंस्टॉल हो गया। होम स्क्रीन पर इसका आइकन खोजें।"
  },
  "iosTitle": {
    "id": "iPhone / iPad (Safari)",
    "en": "iPhone / iPad (Safari)",
    "ar": "iPhone / iPad (Safari)",
    "fr": "iPhone / iPad (Safari)",
    "de": "iPhone / iPad (Safari)",
    "es": "iPhone / iPad (Safari)",
    "ru": "iPhone / iPad (Safari)",
    "zh": "iPhone / iPad（Safari）",
    "ja": "iPhone / iPad（Safari）",
    "ko": "iPhone / iPad (Safari)",
    "hi": "iPhone / iPad (Safari)"
  },
  "ios1": {
    "id": "Buka halaman ini di Safari.",
    "en": "Open this page in Safari.",
    "ar": "افتح هذه الصفحة في Safari.",
    "fr": "Ouvrez cette page dans Safari.",
    "de": "Öffnen Sie diese Seite in Safari.",
    "es": "Abre esta página en Safari.",
    "ru": "Откройте эту страницу в Safari.",
    "zh": "在 Safari 中打开此页面。",
    "ja": "この页を Safari で開いてください。",
    "ko": "Safari에서 이 페이지를 여세요.",
    "hi": "इस पेज को Safari में खोलें।"
  },
  "ios2": {
    "id": "Ketuk tombol Bagikan (kotak dengan panah ke atas) di bilah bawah.",
    "en": "Tap the Share button (box with an upward arrow) in the bottom bar.",
    "ar": "اضغط على زر المشاركة (المربع الذي يحمل سهماً لأعلى) في الشريط السفلي.",
    "fr": "Appuyez sur le bouton Partager (carré avec une flèche vers le haut) dans la barre inférieure.",
    "de": "Tippen Sie auf die Schaltfläche „Teilen\" (Kästchen mit Pfeil nach oben) in der unteren Leiste.",
    "es": "Toca el botón Compartir (cuadro con flecha hacia arriba) en la barra inferior.",
    "ru": "Нажмите кнопку «Поделиться» (прямоугольник со стрелкой вверх) на нижней панели.",
    "zh": "点击底部栏中的分享按钮（带向上箭头的方框）。",
    "ja": "下部バーにある共有ボタン（上向き矢印の付いたボックス）をタップしてください。",
    "ko": "하단 바에 있는 공유 버튼(위쪽 화살표가 있는 상자)을 탭하세요.",
    "hi": "नीचे की बार में शेयर बटन (ऊपर तीर वाला बॉक्स) पर टैप करें।"
  },
  "ios3": {
    "id": "Gulir dan pilih \"Tambahkan ke Layar Utama\".",
    "en": "Scroll and select \"Add to Home Screen\".",
    "ar": "مرِّر واختر \"إضافة إلى الشاشة الرئيسية\".",
    "fr": "Faites défiler et sélectionnez « Ajouter à l'écran d'accueil ».",
    "de": "Scrollen Sie und wählen Sie „Zum Home-Bildschirm hinzufügen\".",
    "es": "Desplázate y selecciona \"Añadir a la pantalla de inicio\".",
    "ru": "Прокрутите и выберите «Добавить на главный экран».",
    "zh": "滚动并选择\"添加到主屏幕\"。",
    "ja": "スクロールして「ホーム画面に追加」を選択してください。",
    "ko": "스크롤하여 \"홈 화면에 추가\"를 선택하세요.",
    "hi": "स्क्रॉल करें और \"होम स्क्रीन में जोड़ें\" चुनें।"
  },
  "ios4": {
    "id": "Ketuk Tambah. Ikon Manasik akan muncul di layar utama.",
    "en": "Tap Add. The Manasik icon will appear on your home screen.",
    "ar": "اضغط على \"إضافة\". سيظهر أيقونة المناسك على شاشتك الرئيسية.",
    "fr": "Appuyez sur Ajouter. L'icône Manasik apparaîtra sur votre écran d'accueil.",
    "de": "Tippen Sie auf Hinzufügen. Das Manasik-Symbol wird auf Ihrem Home-Bildschirm angezeigt.",
    "es": "Toca Añadir. El ícono de Manasik aparecerá en tu pantalla de inicio.",
    "ru": "Нажмите «Добавить». Иконка Manasik появится на главном экране.",
    "zh": "点击\"添加\"。Manasik 图标将出现在您的主屏幕上。",
    "ja": "「追加」をタップしてください。Manasikのアイコンがホーム画面に表示されます。",
    "ko": "추가를 탭하세요. Manasik 아이콘이 홈 화면에 나타납니다.",
    "hi": "जोड़ें पर टैप करें। Manasik का आइकन आपकी होम स्क्रीन पर दिखाई देगा।"
  },
  "otherTitle": {
    "id": "Chrome / Edge / Samsung Internet",
    "en": "Chrome / Edge / Samsung Internet",
    "ar": "Chrome / Edge / Samsung Internet",
    "fr": "Chrome / Edge / Samsung Internet",
    "de": "Chrome / Edge / Samsung Internet",
    "es": "Chrome / Edge / Samsung Internet",
    "ru": "Chrome / Edge / Samsung Internet",
    "zh": "Chrome / Edge / Samsung Internet",
    "ja": "Chrome / Edge / Samsung Internet",
    "ko": "Chrome / Edge / Samsung Internet",
    "hi": "Chrome / Edge / Samsung Internet"
  },
  "other1": {
    "id": "Buka menu browser (ikon ⋮ atau ⋯).",
    "en": "Open the browser menu (⋮ or ⋯ icon).",
    "ar": "افتح قائمة المتصفح (أيقونة ⋮ أو ⋯).",
    "fr": "Ouvrez le menu du navigateur (icône ⋮ ou ⋯).",
    "de": "Öffnen Sie das Browsermenü (Symbol ⋮ oder ⋯).",
    "es": "Abre el menú del navegador (ícono ⋮ o ⋯).",
    "ru": "Откройте меню браузера (значок ⋮ или ⋯).",
    "zh": "打开浏览器菜单（⋮ 或 ⋯ 图标）。",
    "ja": "ブラウザのメニュー（⋮ または ⋯ アイコン）を開いてください。",
    "ko": "브라우저 메뉴(⋮ 또는 ⋯ 아이콘)를 여세요.",
    "hi": "ब्राउज़र मेनू (⋮ या ⋯ आइकन) खोलें।"
  },
  "other2": {
    "id": "Pilih \"Pasang aplikasi\" atau \"Tambahkan ke layar utama\".",
    "en": "Select \"Install app\" or \"Add to home screen\".",
    "ar": "اختر \"تثبيت التطبيق\" أو \"إضافة إلى الشاشة الرئيسية\".",
    "fr": "Sélectionnez « Installer l'application » ou « Ajouter à l'écran d'accueil ».",
    "de": "Wählen Sie „App installieren\" oder „Zum Home-Bildschirm hinzufügen\".",
    "es": "Selecciona \"Instalar aplicación\" o \"Añadir a la pantalla de inicio\".",
    "ru": "Выберите «Установить приложение» или «Добавить на главный экран».",
    "zh": "选择\"安装应用\"或\"添加到主屏幕\"。",
    "ja": "「アプリをインストール」または「ホーム画面に追加」を選択してください。",
    "ko": "\"앱 설치\" 또는 \"홈 화면에 추가\"를 선택하세요.",
    "hi": "\"ऐप इंस्टॉल करें\" या \"होम स्क्रीन में जोड़ें\" चुनें।"
  },
  "other3": {
    "id": "Konfirmasi dengan Pasang.",
    "en": "Confirm by tapping Install.",
    "ar": "أكِّد بالضغط على \"تثبيت\".",
    "fr": "Confirmez en appuyant sur Installer.",
    "de": "Bestätigen Sie mit Installieren.",
    "es": "Confirma tocando Instalar.",
    "ru": "Подтвердите, нажав «Установить».",
    "zh": "点击\"安装\"进行确认。",
    "ja": "「インストール」をタップして確認してください。",
    "ko": "설치를 탭하여 확인하세요.",
    "hi": "इंस्टॉल करें पर टैप करके पुष्टि करें।"
  },
  "notSupported": {
    "id": "Browser ini belum mendukung pemasangan langsung. Gunakan Chrome, Edge, atau Safari (iPhone) — atau unduh APK untuk Android.",
    "en": "This browser does not yet support direct installation. Use Chrome, Edge, or Safari (iPhone) — or download the APK for Android.",
    "ar": "هذا المتصفح لا يدعم التثبيت المباشر بعد. استخدم Chrome أو Edge أو Safari (iPhone) — أو قم بتنزيل ملف APK لنظام Android.",
    "fr": "Ce navigateur ne prend pas encore en charge l'installation directe. Utilisez Chrome, Edge ou Safari (iPhone) — ou téléchargez l'APK pour Android.",
    "de": "Dieser Browser unterstützt die direkte Installation noch nicht. Verwenden Sie Chrome, Edge oder Safari (iPhone) — oder laden Sie die APK für Android herunter.",
    "es": "Este navegador aún no admite la instalación directa. Use Chrome, Edge o Safari (iPhone) — o descargue el APK para Android.",
    "ru": "Этот браузер пока не поддерживает прямую установку. Используйте Chrome, Edge или Safari (iPhone) — или загрузите APK для Android.",
    "zh": "此浏览器尚不支持直接安装。请使用 Chrome、Edge 或 Safari（iPhone）——或为 Android 下载 APK 文件。",
    "ja": "このブラウザはまだ直接インストールに対応していません。Chrome、Edge、またはSafari（iPhone）をご使用ください。またはAndroid用APKをダウンロードしてください。",
    "ko": "이 브라우저는 아직 직접 설치를 지원하지 않습니다. Chrome, Edge 또는 Safari(iPhone)를 사용하거나 Android용 APK를 다운로드하세요.",
    "hi": "यह ब्राउज़र अभी तक सीधी स्थापना का समर्थन नहीं करता। Chrome, Edge, या Safari (iPhone) का उपयोग करें — या Android के लिए APK डाउनलोड करें।"
  },
  "benefit1": {
    "id": "Ikon di layar utama & layar penuh tanpa bilah alamat",
    "en": "Home screen icon & full screen without address bar",
    "ar": "أيقونة على الشاشة الرئيسية وشاشة كاملة بدون شريط العنوان",
    "fr": "Icône sur l'écran d'accueil et plein écran sans barre d'adresse",
    "de": "Symbol auf dem Startbildschirm & Vollbild ohne Adressleiste",
    "es": "Ícono en la pantalla de inicio y pantalla completa sin barra de direcciones",
    "ru": "Значок на главном экране и полноэкранный режим без адресной строки",
    "zh": "主屏幕图标及无地址栏的全屏显示",
    "ja": "ホーム画面のアイコン＆アドレスバーなしの全画面表示",
    "ko": "홈 화면 아이콘 및 주소 표시줄 없는 전체 화면",
    "hi": "होम स्क्रीन आइकन और पता बार रहित पूर्ण स्क्रीन"
  },
  "benefit2": {
    "id": "Bekerja offline untuk doa, manasik & audio tersimpan",
    "en": "Works offline for saved prayers, manasik & audio",
    "ar": "يعمل بدون إنترنت للأدعية والمناسك والصوتيات المحفوظة",
    "fr": "Fonctionne hors ligne pour les prières, manasik et audios enregistrés",
    "de": "Funktioniert offline für gespeicherte Gebete, Manasik & Audio",
    "es": "Funciona sin conexión para du'as, manasik y audios guardados",
    "ru": "Работает офлайн для сохранённых молитв, манасик и аудио",
    "zh": "离线可用，支持已保存的祈祷、朝觐功课（Manasik）及音频",
    "ja": "保存された祈り、マナーシク（Manasik）＆音声をオフラインで利用可能",
    "ko": "저장된 기도, 마나식(Manasik) 및 오디오를 오프라인에서 사용 가능",
    "hi": "सहेजी गई दुआओं, मनासिक और ऑडियो के लिए ऑफ़लाइन काम करता है"
  },
  "benefit3": {
    "id": "Notifikasi pengingat zikir, salat & manasik",
    "en": "Reminder notifications for dhikr, salah & manasik",
    "ar": "إشعارات تذكير للذكر والصلاة والمناسك",
    "fr": "Notifications de rappel pour le dhikr, la salah et les manasik",
    "de": "Erinnerungsbenachrichtigungen für Dhikr, Salah & Manasik",
    "es": "Notificaciones de recordatorio para dhikr, salah y manasik",
    "ru": "Уведомления-напоминания для зикра, намаза и манасик",
    "zh": "迪克尔（Dhikr）、礼拜（Salah）及朝觐功课（Manasik）提醒通知",
    "ja": "ズィクル（Dhikr）、サラー（Salah）＆マナーシク（Manasik）のリマインダー通知",
    "ko": "디크르(Dhikr), 살라(Salah) 및 마나식(Manasik) 알림 제공",
    "hi": "ज़िक्र, सलाह और मनासिक के लिए स्मरण सूचनाएँ"
  },
  "benefit4": {
    "id": "Gratis, tanpa iklan, ringan ({mb} MB)",
    "en": "Free, no ads, lightweight ({mb} MB)",
    "ar": "مجاني، بدون إعلانات، خفيف الحجم ({mb} ميغابايت)",
    "fr": "Gratuit, sans publicités, léger ({mb} Mo)",
    "de": "Kostenlos, werbefrei, leichtgewichtig ({mb} MB)",
    "es": "Gratis, sin anuncios, liviano ({mb} MB)",
    "ru": "Бесплатно, без рекламы, лёгкое приложение ({mb} МБ)",
    "zh": "免费、无广告、轻量（{mb} MB）",
    "ja": "無料、広告なし、軽量（{mb} MB）",
    "ko": "무료, 광고 없음, 가벼운 앱 ({mb} MB)",
    "hi": "निःशुल्क, बिना विज्ञापन, हल्का ({mb} MB)"
  },
  "youAreOn": {
    "id": "Perangkat Anda: {device}",
    "en": "Your device: {device}",
    "ar": "جهازك: {device}",
    "fr": "Votre appareil : {device}",
    "de": "Ihr Gerät: {device}",
    "es": "Su dispositivo: {device}",
    "ru": "Ваше устройство: {device}",
    "zh": "您的设备：{device}",
    "ja": "ご使用のデバイス：{device}",
    "ko": "사용 중인 기기: {device}",
    "hi": "आपका डिवाइस: {device}"
  },
  "devAndroid": {
    "id": "Android",
    "en": "Android",
    "ar": "Android",
    "fr": "Android",
    "de": "Android",
    "es": "Android",
    "ru": "Android",
    "zh": "Android",
    "ja": "Android",
    "ko": "Android",
    "hi": "Android"
  },
  "devIos": {
    "id": "iPhone / iPad",
    "en": "iPhone / iPad",
    "ar": "iPhone / iPad",
    "fr": "iPhone / iPad",
    "de": "iPhone / iPad",
    "es": "iPhone / iPad",
    "ru": "iPhone / iPad",
    "zh": "iPhone / iPad",
    "ja": "iPhone / iPad",
    "ko": "iPhone / iPad",
    "hi": "iPhone / iPad"
  },
  "devDesktop": {
    "id": "Desktop",
    "en": "Desktop",
    "ar": "Desktop",
    "fr": "Desktop",
    "de": "Desktop",
    "es": "Desktop",
    "ru": "Desktop",
    "zh": "Desktop",
    "ja": "Desktop",
    "ko": "Desktop",
    "hi": "Desktop"
  },
  "recommended": {
    "id": "Disarankan",
    "en": "Recommended",
    "ar": "مُوصى به",
    "fr": "Recommandé",
    "de": "Empfohlen",
    "es": "Recomendado",
    "ru": "Рекомендуется",
    "zh": "推荐",
    "ja": "おすすめ",
    "ko": "추천",
    "hi": "अनुशंसित"
  },
  "shareTitle": {
    "id": "Bagikan tautan pemasangan",
    "en": "Share installation link",
    "ar": "شارك رابط التثبيت",
    "fr": "Partager le lien d'installation",
    "de": "Installationslink teilen",
    "es": "Compartir enlace de instalación",
    "ru": "Поделиться ссылкой для установки",
    "zh": "分享安装链接",
    "ja": "インストールリンクを共有する",
    "ko": "설치 링크 공유",
    "hi": "इंस्टॉलेशन लिंक साझा करें"
  },
  "shareText": {
    "id": "Pasang aplikasi Manasik — panduan Umrah & Haji lengkap dalam 11 bahasa: {url}",
    "en": "Install the Manasik app — a complete Umrah & Hajj guide in 11 languages: {url}",
    "ar": "ثبِّت تطبيق مناسك — دليل شامل للعمرة والحج بـ11 لغة: {url}",
    "fr": "Installez l'application Manasik — un guide complet pour la Omra & le Hajj en 11 langues : {url}",
    "de": "Installiere die Manasik-App — ein vollständiger Umrah- & Hajj-Leitfaden in 11 Sprachen: {url}",
    "es": "Instala la aplicación Manasik — una guía completa de Umrah y Hajj en 11 idiomas: {url}",
    "ru": "Установите приложение Manasik — полное руководство по Умре и Хаджу на 11 языках: {url}",
    "zh": "安装 Manasik 应用程序——11 种语言的完整小朝（Umrah）与大朝（Hajj）指南：{url}",
    "ja": "Manasikアプリをインストールしてください — 11言語対応のウムラ＆ハッジ完全ガイド：{url}",
    "ko": "Manasik 앱을 설치하세요 — 11개 언어로 제공되는 완전한 우므라 & 하지 가이드: {url}",
    "hi": "Manasik ऐप इंस्टॉल करें — 11 भाषाओं में उमरा और हज की संपूर्ण मार्गदर्शिका: {url}"
  },
  "shareBtn": {
    "id": "Bagikan ke jamaah",
    "en": "Share with fellow pilgrims",
    "ar": "شارك مع الحجاج",
    "fr": "Partager avec les pèlerins",
    "de": "Mit Pilgern teilen",
    "es": "Compartir con los peregrinos",
    "ru": "Поделиться с паломниками",
    "zh": "与朝圣者分享",
    "ja": "巡礼者と共有する",
    "ko": "순례자들과 공유하기",
    "hi": "साथी हाजियों के साथ साझा करें"
  },
  "shareCopied": {
    "id": "Tautan pemasangan disalin",
    "en": "Installation link copied",
    "ar": "تم نسخ رابط التثبيت",
    "fr": "Lien d'installation copié",
    "de": "Installationslink kopiert",
    "es": "Enlace de instalación copiado",
    "ru": "Ссылка для установки скопирована",
    "zh": "安装链接已复制",
    "ja": "インストールリンクをコピーしました",
    "ko": "설치 링크가 복사되었습니다",
    "hi": "इंस्टॉलेशन लिंक कॉपी किया गया"
  },
  "loginBtn": {
    "id": "Masuk / Daftar",
    "en": "Log In / Register",
    "ar": "تسجيل الدخول / التسجيل",
    "fr": "Connexion / Inscription",
    "de": "Anmelden / Registrieren",
    "es": "Iniciar sesión / Registrarse",
    "ru": "Войти / Зарегистрироваться",
    "zh": "登录 / 注册",
    "ja": "ログイン / 登録",
    "ko": "로그인 / 회원가입",
    "hi": "लॉग इन / पंजीकरण"
  },
  "homeBtn": {
    "id": "Ke Beranda",
    "en": "Go to Home",
    "ar": "الذهاب إلى الرئيسية",
    "fr": "Aller à l'accueil",
    "de": "Zur Startseite",
    "es": "Ir al inicio",
    "ru": "На главную",
    "zh": "前往主页",
    "ja": "ホームへ",
    "ko": "홈으로 이동",
    "hi": "होम पर जाएं"
  },
  "publicNote": {
    "id": "Setelah terpasang, masuk atau daftar gratis untuk menyimpan progres manasik, catatan, dan pengingat Anda.",
    "en": "Once installed, log in or register for free to save your Manasik progress, notes, and reminders.",
    "ar": "بعد التثبيت، سجِّل الدخول أو أنشئ حسابًا مجانًا لحفظ تقدُّمك في المناسك وملاحظاتك وتذكيراتك.",
    "fr": "Une fois installée, connectez-vous ou inscrivez-vous gratuitement pour sauvegarder votre progression dans les Manasik, vos notes et vos rappels.",
    "de": "Nach der Installation melden Sie sich an oder registrieren Sie sich kostenlos, um Ihren Manasik-Fortschritt, Notizen und Erinnerungen zu speichern.",
    "es": "Una vez instalada, inicia sesión o regístrate gratis para guardar tu progreso en los Manasik, notas y recordatorios.",
    "ru": "После установки войдите или зарегистрируйтесь бесплатно, чтобы сохранить свой прогресс в Манасик, заметки и напоминания.",
    "zh": "安装后，免费登录或注册，以保存您的朝觐功课（Manasik）进度、笔记和提醒。",
    "ja": "インストール後、無料でログインまたは登録して、マナシク（Manasik）の進捗、メモ、リマインダーを保存してください。",
    "ko": "설치 후 무료로 로그인하거나 회원가입하여 마나시크(Manasik) 진행 상황, 메모 및 알림을 저장하세요.",
    "hi": "इंस्टॉल करने के बाद, अपनी मनासिक (Manasik) प्रगति, नोट्स और रिमाइंडर सहेजने के लिए मुफ़्त में लॉग इन या पंजीकरण करें।"
  },
  "updateTitle": {
    "id": "Versi baru Manasik {v} tersedia",
    "en": "New version of Manasik {v} is available",
    "ar": "إصدار جديد من تطبيق المناسك {v} متاح الآن",
    "fr": "Une nouvelle version de Manasik {v} est disponible",
    "de": "Neue Version von Manasik {v} ist verfügbar",
    "es": "Nueva versión de Manasik {v} disponible",
    "ru": "Доступна новая версия Manasik {v}",
    "zh": "Manasik {v} 新版本已发布",
    "ja": "Manasik {v} の新しいバージョンが利用可能です",
    "ko": "Manasik {v} 새 버전을 사용할 수 있습니다",
    "hi": "Manasik {v} का नया संस्करण उपलब्ध है"
  },
  "updateHint": {
    "id": "Unduh dan pasang pembaruan di atas aplikasi lama — data dan pengaturan Anda tetap tersimpan.",
    "en": "Download and install the update over the old app — your data and settings will be kept.",
    "ar": "قم بتنزيل التحديث وتثبيته فوق التطبيق القديم — ستظل بياناتك وإعداداتك محفوظة.",
    "fr": "Téléchargez et installez la mise à jour par-dessus l'ancienne application — vos données et paramètres seront conservés.",
    "de": "Laden Sie das Update herunter und installieren Sie es über der alten App — Ihre Daten und Einstellungen bleiben erhalten.",
    "es": "Descarga e instala la actualización sobre la aplicación antigua — tus datos y configuraciones se mantendrán.",
    "ru": "Скачайте и установите обновление поверх старого приложения — ваши данные и настройки сохранятся.",
    "zh": "在旧应用上直接下载并安装更新——您的数据和设置将完整保留。",
    "ja": "古いアプリの上からアップデートをダウンロードしてインストールしてください — データと設定はそのまま保持されます。",
    "ko": "기존 앱 위에 업데이트를 다운로드하여 설치하세요 — 데이터와 설정은 그대로 유지됩니다.",
    "hi": "पुराने ऐप के ऊपर अपडेट डाउनलोड और इंस्टॉल करें — आपका डेटा और सेटिंग्स सुरक्षित रहेंगे।"
  },
  "updateBtn": {
    "id": "Unduh pembaruan ({mb} MB)",
    "en": "Download update ({mb} MB)",
    "ar": "تنزيل التحديث ({mb} ميغابايت)",
    "fr": "Télécharger la mise à jour ({mb} Mo)",
    "de": "Update herunterladen ({mb} MB)",
    "es": "Descargar actualización ({mb} MB)",
    "ru": "Скачать обновление ({mb} МБ)",
    "zh": "下载更新（{mb} MB）",
    "ja": "アップデートをダウンロード（{mb} MB）",
    "ko": "업데이트 다운로드 ({mb} MB)",
    "hi": "अपडेट डाउनलोड करें ({mb} MB)"
  },
  "updateLater": {
    "id": "Nanti",
    "en": "Later",
    "ar": "لاحقاً",
    "fr": "Plus tard",
    "de": "Später",
    "es": "Más tarde",
    "ru": "Позже",
    "zh": "稍后",
    "ja": "後で",
    "ko": "나중에",
    "hi": "बाद में"
  },
  "updateSteps": {
    "id": "Buka berkas yang terunduh → ketuk Perbarui → buka kembali Manasik.",
    "en": "Open the downloaded file → tap Update → reopen Manasik.",
    "ar": "افتح الملف المُنزَّل ← اضغط على تحديث ← أعد فتح تطبيق Manasik.",
    "fr": "Ouvrez le fichier téléchargé → appuyez sur Mettre à jour → rouvrez Manasik.",
    "de": "Öffnen Sie die heruntergeladene Datei → tippen Sie auf Aktualisieren → öffnen Sie Manasik erneut.",
    "es": "Abra el archivo descargado → toque Actualizar → vuelva a abrir Manasik.",
    "ru": "Откройте загруженный файл → нажмите Обновить → снова откройте Manasik.",
    "zh": "打开已下载的文件 → 点击更新 → 重新打开 Manasik。",
    "ja": "ダウンロードしたファイルを開く → アップデートをタップ → Manasikを再起動する。",
    "ko": "다운로드한 파일 열기 → 업데이트 탭 → Manasik 다시 열기.",
    "hi": "डाउनलोड की गई फ़ाइल खोलें → अपडेट पर टैप करें → Manasik को पुनः खोलें।"
  },
  "apkUpToDate": {
    "id": "Aplikasi Android Anda sudah versi terbaru ({v}).",
    "en": "Your Android app is already the latest version ({v}).",
    "ar": "تطبيق Android لديك يعمل بالإصدار الأحدث ({v}).",
    "fr": "Votre application Android est déjà à la dernière version ({v}).",
    "de": "Ihre Android-App ist bereits auf dem neuesten Stand ({v}).",
    "es": "Su aplicación Android ya está en la versión más reciente ({v}).",
    "ru": "Ваше приложение Android уже является последней версией ({v}).",
    "zh": "您的 Android 应用已是最新版本（{v}）。",
    "ja": "お使いのAndroidアプリはすでに最新バージョン（{v}）です。",
    "ko": "귀하의 Android 앱은 이미 최신 버전({v})입니다.",
    "hi": "आपका Android ऐप पहले से नवीनतम संस्करण ({v}) पर है।"
  },
  "apkOutdated": {
    "id": "Pembaruan tersedia: versi {v}. Unduh APK di bawah untuk memperbarui.",
    "en": "Update available: version {v}. Download the APK below to update.",
    "ar": "يتوفر تحديث: الإصدار {v}. نزِّل ملف APK أدناه للتحديث.",
    "fr": "Mise à jour disponible : version {v}. Téléchargez l'APK ci-dessous pour mettre à jour.",
    "de": "Update verfügbar: Version {v}. Laden Sie die APK unten herunter, um zu aktualisieren.",
    "es": "Actualización disponible: versión {v}. Descargue el APK a continuación para actualizar.",
    "ru": "Доступно обновление: версия {v}. Загрузите APK ниже для обновления.",
    "zh": "有可用更新：版本 {v}。请下载下方的 APK 进行更新。",
    "ja": "アップデートが利用可能です：バージョン {v}。下記のAPKをダウンロードしてアップデートしてください。",
    "ko": "업데이트 사용 가능: 버전 {v}. 업데이트하려면 아래 APK를 다운로드하세요.",
    "hi": "अपडेट उपलब्ध है: संस्करण {v}। अपडेट करने के लिए नीचे APK डाउनलोड करें।"
  },
  "apkRunning": {
    "id": "Anda sedang menggunakan aplikasi Android Manasik.",
    "en": "You are currently using the Manasik Android app.",
    "ar": "أنت تستخدم حالياً تطبيق Manasik على Android.",
    "fr": "Vous utilisez actuellement l'application Android Manasik.",
    "de": "Sie verwenden derzeit die Manasik Android-App.",
    "es": "Actualmente está utilizando la aplicación Android Manasik.",
    "ru": "Вы сейчас используете Android-приложение Manasik.",
    "zh": "您当前正在使用 Manasik Android 应用。",
    "ja": "現在、Manasik Androidアプリをご利用中です。",
    "ko": "현재 Manasik Android 앱을 사용 중입니다.",
    "hi": "आप अभी Manasik Android ऐप का उपयोग कर रहे हैं।"
  }
};
